import { ChevronUp, ChevronDown } from 'react-bootstrap-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { memo } from 'react'
import { isNonEmptyArray, isNonEmptyObject } from '@/utils/checks'
import type { Containers } from '@/domain/useCases/navBar/constants'
interface MobileNavLinksProps {
  items?: {
    label?: string
    name: string
    link: string
  }[]
  itemGroups?: {
    [key: string]: {
      label?: string
      name: string
      link: string
    }[]
  }
  className?: string
  label: string
  toggleOpen: (label: Containers | string) => void
  currentlyOpen: string | null
  shouldShowLabel?: boolean
}

const linkOverideStyle = '!text-lg !font-medium text-gray-700'

export const NavSubItems = ({
  items,
  label,
  toggleOpen,
  currentlyOpen,
  shouldShowLabel = true,
  itemGroups,
  className = ''
}: MobileNavLinksProps): JSX.Element & Partial<HTMLDivElement> => {
  const open = currentlyOpen == label

  return (
    <div className={`${className}`}>
      {shouldShowLabel && (
        <h3
          className="flex items-center gap-x-2 text-lg font-medium text-gray-800"
          onClick={() => toggleOpen(label)}
        >
          {label}
          {items && open ? (
            <ChevronUp className="size-[16px] text-gray-800" />
          ) : (
            <ChevronDown className="size-[16px] text-gray-800 transition-all duration-100" />
          )}
        </h3>
      )}
      {open && isNonEmptyArray(items) && (
        <ul
          className={`flex flex-col gap-y-2 py-2 ${
            shouldShowLabel ? 'pl-2' : 'pl-0'
          }`}
        >
          {items.map((item) => (
            <li
              key={item.link}
              className="flex text-gray-700"
            >
              <a
                href={item.link}
                className={linkOverideStyle}
              >
                {item.name || item?.label}
              </a>
            </li>
          ))}
        </ul>
      )}

      {isNonEmptyObject(itemGroups) &&
        Object.entries(itemGroups).map(([key, value]) => {
          return (
            <div
              key={key}
              className="pb-4"
            >
              <h4 className="text-xl !font-medium !text-gray-1100">{key}</h4>
              <ul
                className={`flex flex-col gap-y-2 py-2 ${
                  shouldShowLabel ? 'pl-2' : 'pl-0'
                }`}
              >
                {Object.entries(value).map(([k, v]) => (
                  <li
                    key={v.link}
                    className="flex text-gray-800"
                  >
                    <a
                      href={v.link}
                      className={linkOverideStyle}
                    >
                      {v.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )
        })}
    </div>
  )
}

export default memo(NavSubItems)
